export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/InsurContractTp',
		name: 'NbuInsurContractTp',
		title: {
			single: 'NbuInsurContractTp',
			plural: 'NbuInsurContractTps'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "P",
				"code": null,
				"name": "Поліс",
				"caption": "Поліс",
				"isBlocked": false
			},
			{
				"id": "D",
				"code": null,
				"name": "Договор",
				"caption": "Договор",
				"isBlocked": false
			}
		]
	},
}
